import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IConfirmationObj } from "src/pages/Studies/models/interfaces";

interface IUnsavedChangesState {
	hasUnsavedChanges: boolean;
	confirmationData: IConfirmationObj;
	isSavedDisabled: boolean;
}

const unsavedChangesSlice = createSlice({
	name: "unsavedChanges",
	initialState: {
		hasUnsavedChanges: false,
		confirmationData: { redirectFrom: "", status: "", editType: "", visible: false, name: "" },
		isSavedDisabled: false,
	} as IUnsavedChangesState,
	reducers: {
		setUnsavedChanges: (state, action: PayloadAction<boolean>) => {
			state.hasUnsavedChanges = action.payload;
		},
		setConfirmationData: (state, action: PayloadAction<IConfirmationObj>) => {
			state.confirmationData = action.payload;
		},
		setIsSavedDisabled: (state, action: PayloadAction<boolean>) => {
			state.isSavedDisabled = action.payload;
		},
	},
});

export const { setConfirmationData, setIsSavedDisabled, setUnsavedChanges } = unsavedChangesSlice.actions;

export default unsavedChangesSlice.reducer;
